import { DeviceScreen } from "../../utils/Constant";
import {
    isBrowser,
    isTablet,
    isMobile
} from "react-device-detect";
// types value
const types =  {
    SCREEN_MOBILE: "SCREEN_MOBILE",
    SCREEN_TABLET: "SCREEN_TABLET",
    SCREEN_DESKTOP: "SCREEN_DESKTOP"
}

// actions function with dispatch
export const actions = {
    checkScreen: (width :number) => {
        if (isMobile) return { type : types.SCREEN_MOBILE}
        if (width >= 1200 && isBrowser) return { type : types.SCREEN_DESKTOP}
        if ((width > 500 && width < 1200) || isTablet ) return { type : types.SCREEN_TABLET}
        return { type : types.SCREEN_MOBILE}
    }
}

const initialState = {
    screenView : "MOBILE"
};

// reducer
export const deviceReducer = (state = initialState, action: any)  => {
    switch (action.type) {
        case types.SCREEN_MOBILE:
            return {
                ...state,
                screenView : DeviceScreen.MOBILE,
            };
        case types.SCREEN_TABLET:
            return {
                ...state,
                screenView : DeviceScreen.TABLET,
            };
        case types.SCREEN_DESKTOP:
            return {
                ...state,
                screenView : DeviceScreen.DESKTOP,
            }
        default:
            return state;
    }
}